.container {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: var(--border-radius-medium);
}

.affix {
  font-size: 2rem;
  font-weight: 500;
  color: var(--white-default);
  padding: 0.4rem;
  cursor: pointer;
  user-select: none;

  :hover {
    opacity: 0.8;
  }
}

.input {
  /* removing default appearance */
  -webkit-appearance: none;
  appearance: none;

  height: 0.8rem;
  background: #313236;
  border-radius: var(--border-radius-medium);
  width: 100%;
  cursor: pointer;
  background-image: linear-gradient(var(--color-secondary), var(--color-secondary));
  background-repeat: no-repeat;
  margin: 0 0.8rem;

  /* Track: webkit*/
  ::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }

  /* Track: Mozilla Firefox */
  ::-moz-range-track {
    -webkit-appearance: none;
    box-shadow: none;
    border: none;
    background: transparent;
  }

  /* Thumb: webkit */
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 1.6rem;
    width: 1.6rem;
    border-radius: 50%;
    background: var(--color-secondary);
    cursor: pointer;
    box-shadow: 0 0 2px 0 #367bff;
    transition: background 0.3s ease-in-out;

    :hover {
      box-shadow: #367bff50 0px 0px 0px 4px;
    }

    :active {
      box-shadow: #367bff50 0px 0px 0px 6px;
      transition: box-shadow 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        left 350ms cubic- bezier(0.4, 0, 0.2, 1) 0ms, bottom 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
  }

  /* Thumb: Firefox */
  ::-moz-range-thumb {
    height: 1.6rem;
    width: 1.6rem;
    border-radius: 50%;
    background: var(--color-secondary);
    cursor: pointer;
    transition: background 0.3s ease-in-out;
    border: none;

    :hover {
      box-shadow: #367bff50 0px 0px 0px 4px;
    }

    :active {
      box-shadow: #367bff50 0px 0px 0px 6px;
      transition: box-shadow 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        left 350ms cubic- bezier(0.4, 0, 0.2, 1) 0ms, bottom 350ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
  }
}
